<template>
  <div :class="type == undefined? 'household_frame':'household_frame_KNS'">
    <el-dialog
      title="請選擇住戶資訊(棟別、樓層、戶別)"
      :visible.sync="openSwitch"
      :close-on-click-modal="false"
      :show-close="isShowClose"
      width="900px"
    >
      <span
        v-if="title != undefined"
        slot="title"
        class="dialog-title"
      >
        <div class="title-bar">
          <span class="title">
            {{ title.title }}
            <span
              v-if="title.introduction"
              class="introduction"
              @click="helpDocClick(title.introduction, {
                product_id: 'resident_onboarding',
                product_name: $t('CommunityMainService.BindingHousehold'),
                subpage_name: '無' })"
            >{{ $t("General.Instructions") }}</span>
          </span>
          <span class="subtitle">{{ title.SubTitle }}</span>
        </div>
        <div
          v-if="title.btn != undefined"
          class="advanced-cog"
          @click="title.btn.btnevent"
        >
          <i
            :class="title.btn.icon"
            aria-hidden="true"
          />
          {{ title.btn.text }}
        </div>
      </span>
      <div class="list_wrap">
        <template v-for="(lv,li) in houseList">
          <div
            :key="'block'+li"
            class="list_block"
          >
            <ol
              v-loading="loading[li]"
              style="height: 323px"
            >
              <p class="title">
                {{ lv.title }}
              </p>
              <li
                v-for="(iv, ii) in lv.listItems"
                :key="ii"
                :class="{'active':JSON.stringify(activeData[li])==JSON.stringify(iv)}"
                @click="selectItem(li,iv)"
              >
                <span v-if="lv.name=='Tags'">{{ iv.Tag }}</span>
                <span v-if="lv.name=='Floors'">{{ $t('Household.Floor', {floor: iv.Floor}) }}</span>
                <span v-if="lv.name=='Notes'">{{ iv.TabletNote }}</span>
              </li>
            </ol>
          </div>
          <div
            v-if="li+1<houseList.length"
            :key="'arrow'+li"
            class="list_arrow"
          >
            <i
              class="el-icon-arrow-right"
              aria-hidden="true"
            />
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { checkIsLoginValid } from '@/js/utils/index.js'
import { housekeeperAPI } from '@/api/HousekeeperAPI.js'
import { helpDocClick } from '@/js/utils/handleGA.js'

export default {
  props: {
    open: Boolean,
    type: '',
    title: Object,
    isShowClose: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showVirtual: true, // 是否顯示虛擬戶
      loading: [false, false, false],
      activeBlock: 0,
      activeData: [],
      houseList: [
        {
          title: '請選擇棟別',
          name: 'Tags',
          listItems: []
        },
        {
          title: '請選擇樓層',
          name: 'Floors',
          postData: ['tag'],
          listItems: []
        },
        {
          title: '請選擇戶別',
          name: 'Notes',
          postData: ['tag', 'floor'],
          listItems: []
        }
      ]
    }
  },
  computed: {
    openSwitch: {
      get: function () {
        return this.open
      },
      set: function (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    activeBlock (index) {
      this.houseList.forEach((val, ind) => {
        if (ind > index + 1) {
          val.listItems.length = 0
        }
      })
      this.activeData.filter((val, ind) => {
        if (ind > index) {
          return val
        }
      })
    },
    open (val) {
      if (val) this.initList()
    }
  },
  methods: {
    helpDocClick,
    initList () {
      this.getComTag()
      this.showVirtual = true
    },
    openNotShowVirtual () { // 開啟彈窗，並設定不顯示虛擬戶別
      console.log('開啟彈窗，並設定不顯示虛擬戶別')
      this.openSwitch = true
      this.showVirtual = false
    },
    selectItem (blockIndex, itemValue) { // 點選欄位項目
      this.activeBlock = blockIndex
      this.activeData = _cloneDeep(this.activeData.filter((val, ind) => { // 清除歷史點擊資料
        if (ind < blockIndex) {
          return val
        }
      }))
      this.activeData.push(itemValue) // 新增歷史點擊資料
      // eslint-disable-next-line eqeqeq
      if (blockIndex + 1 == this.houseList.length) { // 結束選擇
        this.finishSelected(itemValue)
      } else {
        this.getList(this.houseList[blockIndex + 1].name)
      }
    },
    finishSelected (note) { // 選擇結束
      this.$emit('select-household', note)
    },
    getList (listName) { // 取得項目列表
      switch (listName) {
      case 'Tags':
        break
      case 'Floors':
        this.getComFloor(this.activeData[0])
        break
      case 'Notes':
        this.getComNote(this.activeData[0], this.activeData[1])
        break
      default:
        this.getComTag()
        break
      }
    },
    async getComTag () { // 取得棟別
      if (!checkIsLoginValid()) {
        return
      }
      this.loading[0] = true
      try {
        const { data } = await housekeeperAPI.getCommunityTabletTag()
        this.houseList[0].listItems = data.Data.Tags
      } catch (error) {
        this.$message({
          message: this.$t('Household.GetBuildingFailed'),
          type: 'warning'
        })
        console.error(error)
      } finally {
        this.loading[0] = false
      }
    },
    async getComFloor (tag) { // 取得樓層
      this.loading[1] = true
      try {
        const { data } = await housekeeperAPI.getCommunityTabletFloor(tag.Tag)
        this.houseList[1].listItems = data.Data.Floors
      } catch (error) {
        this.$message({
          message: '取得樓層失敗，請稍後再試',
          type: 'warning'
        })
        console.error(error)
      } finally {
        this.loading[1] = false
      }
    },
    async getComNote (tag, floor) { // 取得戶別
      this.loading[2] = true
      try {
        const { data } = await housekeeperAPI.getCommunityTabletNote(tag.Tag, floor.Floor)
        if (this.showVirtual) { // 顯示虛擬戶
          this.houseList[2].listItems = data.Data.TabletNotes
        } else {
          // 不顯示虛擬戶
          this.houseList[2].listItems = data.Data.TabletNotes.filter(el => el.IsVirtual === 0)
        }
      } catch (error) {
        this.$message({
          message: '取得戶別失敗，請稍後再試',
          type: 'warning'
        })
        console.error(error)
      } finally {
        this.loading[2] = false
      }
    },
    clearHousehold () { // 清除選擇的住戶
      this.loading = [false, false, false]
      this.activeBlock = 0
      this.activeData = []
      this.houseList = [
        {
          title: '請選擇棟別',
          name: 'Tags',
          listItems: []
        },
        {
          title: '請選擇樓層',
          name: 'Floors',
          postData: ['tag'],
          listItems: []
        },
        {
          title: '請選擇戶別',
          name: 'Notes',
          postData: ['tag', 'floor'],
          listItems: []
        }
      ]
      this.initList()
    }
  }
}
</script>
<style lang="sass" scoped>
.household_frame
  ::v-deep .el-dialog
    +basicDialog
  .list_wrap
    display: flex
    justify-content: space-between
    height: 330px
    font-size: map-get($fontSize,large)
    text-align: left
    .list_block
      cursor: pointer
      width: 27.5%
      border: 1px solid $borderDark1
      padding: 5px
      padding-bottom: 0px
      overflow: auto
      .title
        color: $subFontColor
        padding: 4px 0
      li
        color: $mainFontColor
        padding: 4px 0
        &:hover
          background-color: $defaultColorHover
        &.active
          background-color: $whiteHover
    .list_arrow
      align-self: center
.household_frame_KNS
  ::v-deep .el-dialog
    +KNSDialog
  .list_wrap
    display: flex
    justify-content: space-between
    height: 330px
    font-size: map-get($fontSize,large)
    text-align: left
    .list_block
      cursor: pointer
      width: 27.5%
      border: 1px solid $borderDark1
      padding: 5px
      padding-bottom: 0px
      overflow: auto
      .title
        color: $subFontColor
        padding: 4px 0
      li
        color: $mainFontColor
        padding: 4px 0
        &:hover
          background-color: $defaultColorHover
        &.active
          background-color: $whiteHover
    .list_arrow
      align-self: center
</style>
